import { DI } from '@intigral/constant/config/DIContainer';
import { container } from '../../../DataDomain';
import { ILearnActionRepository } from '../../repositories/interfaces/iLearnActionRepository';
import { ISetPreferencesActionPayload, ISetPreferencesActionResponse } from '../../../entity/interface/iLearnAction';

export interface ISetPreferencesActionUseCase {
    execute(
        apiKey: string,
        payload: ISetPreferencesActionPayload,
        identityToken: string,
        authToken: string,
        epochMs?: string,
        encPassword?: string
    ): Promise<ISetPreferencesActionResponse>;
}

export class SetPreferencesActionUseCase implements ISetPreferencesActionUseCase {
    // Lazy getter for repository to avoid circular dependencies
    private get setPreferencesActionRepository(): ILearnActionRepository {
        return container.resolve<ILearnActionRepository>(DI.REPOSITORIES.ILearnActionRepository);
    }
    constructor() {
        // No initialization needed - dependencies resolved lazily via getters
    }
    async execute(
        apiKey: string,
        payload: ISetPreferencesActionPayload,
        identityToken: string,
        authToken: string,
        epochMs?: string,
        encPassword?: string
    ): Promise<any> {
        return this.setPreferencesActionRepository.setPreferencesAction(
            apiKey,
            payload,
            identityToken,
            authToken,
            epochMs,
            encPassword
        );
    }
}
